import { render, staticRenderFns } from "./truckorder.vue?vue&type=template&id=1c3f96f0&scoped=true&"
import script from "./truckorder.vue?vue&type=script&lang=js&"
export * from "./truckorder.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=1c3f96f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f96f0",
  null
  
)

export default component.exports